<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, handleBlur, errorMessage }">
      <!-- @vue-expect-error FIXME: value not assignable to type 'String | Date | Date[]' -->
      <Calendar
        :modelValue="value"
        v-bind="$attrs"
        @update:modelValue="handleChange"
        @blur="handleBlur"
        :class="{ 'p-invalid': errorMessage }"
        ref="calendar"
      >
        <template v-if="label" #label>{{ label }}</template>
        <template v-if="errorMessage" #helperText>{{ errorMessage }}</template>

        <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
          <slot v-if="slot" :name="slot" v-bind="scope" />
        </template>
      </Calendar>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { Calendar } from './../../../core/controls';
import { FieldValidator } from './../field-validator';
import { ref } from 'vue';

defineOptions({
  name: 'CalendarField',
  inheritAttrs: false,
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
});

const calendar = ref<InstanceType<typeof Calendar>>();

defineExpose({ calendar });
</script>
